<template>
  <!-- App.vue -->

  <v-app>
    <v-app-bar v-if="displayBar" app :color="color" dark>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  props: ['source'],
  computed: {
    title() {
      return document.title
    }
  },
  data: () => ({
    drawer: null,
    color: "glay",
    displayBar: true,
  }),
  methods: {},
  watch:{
    $route(to){
      if (to.name == "chart") {
         this.displayBar = false;
      } else {
        this.displayBar = true;
      }
    }
  } 
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
